import { createValidator } from 'util/validation'

import { RequisicaoExameMamografiaFormValues } from './model-mamografia'

// [TODO] DeLorean: implementar validators
export const mamografiaAnamneseValidator = createValidator<RequisicaoExameMamografiaFormValues>({})

export const mamografiaIndicacaoClinicaValidator = createValidator<RequisicaoExameMamografiaFormValues>({})

export const mamografiaDadosExameValidator = createValidator<RequisicaoExameMamografiaFormValues>({})
